import {
  Component,
  OnInit,
  PLATFORM_ID,
  Inject,
  ViewChild,
  AfterViewInit,
  NgZone,
} from '@angular/core';
import { Papa } from 'ngx-papaparse';
import { Subscription } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Chart } from 'chart.js';
import {
  PamlabApiServiceService,
  DataService,
  RouteService,
  SnackbarService,
} from '@/shared/services';
import { CohortReturn, StudentReturn } from '../../../../../server/types';
import { FilterSelect } from '@/core/interfaces';
import * as _ from 'lodash-es';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

@Component({
  selector: 'cohort-info-content',
  templateUrl: './cohort-info-content.component.html',
  styleUrls: ['./cohort-info-content.component.css'],
  standalone: false,
})
export class CohortInfoContentComponent implements OnInit, AfterViewInit {
  public dataPending!: boolean;
  private subscription: Subscription = new Subscription();

  public students!: Partial<StudentReturn>[];
  public filterValues: { [key: string]: string } = {};
  public displayedColumns: string[] = [
    'uwf_id',
    'name',
    'cohort',
    'admit_type',
    'term',
    'year_code',
    'classification',
    'college',
    'department',
    'uwf_gpa',
    'apr_status',
    'high_school_gpa',
    'tier',
    'gender',
    'ethnicity',
    'canvas_at_risk',
    'dropout_risk',
    'graduation_status',
    'senior_grant_ind',
    'prior_hours',
    'last_semester_attended',
    'last_semester_hours_taken',
    'pell_first_semester_ind',
    'total_univ_hours',
    'enroll_status',
    'current_earn_hrs',
    'active_status',
    'sep_max_grad_term',
  ];
  public tableData: MatTableDataSource<Partial<StudentReturn>> =
    new MatTableDataSource();
  public multiSelectColumns: string[] = [
    'cohort',
    'admit_type',
    'classification',
    'tier',
    'dropout_risk',
    'sep_max_grad_term',
  ];
  public disabledValues = ['All'];
  public studentDataKeys!: string[];
  public defaultValue = 'All';
  public errorMessage = '';
  public filterDictionary = new Map<string, string>();
  public customChartForm = new FormGroup({
    xaxis: new FormControl('cohort', [Validators.required]),
    attribute: new FormControl('canvas_at_risk'),
    group: new FormControl('college'),
    filteredXaxisAttrs: new FormControl<FilterSelect[]>([]),
    filteredAttrAttrs: new FormControl<FilterSelect[]>([]),
    filteredGroupAttrs: new FormControl<FilterSelect[]>([]),
  });
  public cohortData!: CohortReturn;
  public fticDropoutProneChart!: Chart;
  public filterSelectObj: FilterSelect[] = [
    {
      name: 'COHORT',
      columnProp: 'cohort',
      options: [],
      defaultValue: [this.defaultValue],
    },
    {
      name: 'ADMIT TYPE',
      columnProp: 'admit_type',
      options: [],
      defaultValue: [this.defaultValue],
    },
    {
      name: 'YEAR',
      columnProp: 'year_code',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'TIER',
      columnProp: 'tier',
      options: [],
      defaultValue: [this.defaultValue],
    },
    {
      name: 'COLLEGE',
      columnProp: 'college',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'PROGRAM',
      columnProp: 'program_cip_desc',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'PRIOR HOURS',
      columnProp: 'prior_hours',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'ENROLL STATUS',
      columnProp: 'enroll_status',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'ACTIVE STATUS',
      columnProp: 'active_status',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'LAST SEMESTER ATTENDED',
      columnProp: 'last_semester_attended',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'PELL FIRST SEMESTER IND',
      columnProp: 'pell_first_semester_ind',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'GRAD STATUS',
      columnProp: 'graduation_status',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'SENIOR GRANT',
      columnProp: 'senior_grant_ind',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'CLASSIFICATION',
      columnProp: 'classification',
      options: [],
      defaultValue: [this.defaultValue],
    },
    {
      name: 'AT RISK (CANVAS)',
      columnProp: 'canvas_at_risk',
      options: [],
      defaultValue: this.defaultValue,
    },
    {
      name: 'DROPOUT RISK',
      columnProp: 'dropout_risk',
      options: [],
      defaultValue: [this.defaultValue],
    },
    {
      name: 'MAX SEP',
      columnProp: 'sep_max_grad_term',
      options: [],
      defaultValue: [this.defaultValue],
    },
  ];

  public customChartAttributes: FilterSelect[] = [
    {
      name: 'COHORT',
      columnProp: 'cohort',
    },
    {
      name: 'ADMIT TYPE',
      columnProp: 'admit_type',
    },
    {
      name: 'YEAR',
      columnProp: 'year_code',
    },
    {
      name: 'TIER',
      columnProp: 'tier',
    },
    {
      name: 'COLLEGE',
      columnProp: 'college',
    },
    {
      name: 'ENROLL STATUS',
      columnProp: 'enroll_status',
    },
    {
      name: 'ACTIVE STATUS',
      columnProp: 'active_status',
    },
    {
      name: 'GRAD STATUS',
      columnProp: 'graduation_status',
    },
    {
      name: 'CLASSIFICATION',
      columnProp: 'classification',
    },
    {
      name: 'AT RISK (CANVAS)',
      columnProp: 'canvas_at_risk',
    },
    {
      name: 'DROPOUT RISK',
      columnProp: 'dropout_risk',
    },
  ];
  private collegesMap: { [college: string]: string } = {
    'Hal Marcus College of Science and Engineering': 'HMCSE',
    'School of Education': 'SoE',
    'Lewis Bear Jr College of Business': 'LBJCOB',
    'Usha Kundu, MD College of Health': 'UKCOH',
    'College of Arts, Social Sciences and Humanities': 'CASSH',
  };
  public root!: am5.Root;
  private chart!: am5xy.XYChart;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  tooltipMessage: string = `FTIC: First Time In College;
                            FCS: Florida College System;
                            Other: Non-Florida College System;
                            AA: Associate in arts degree;
                            AS: Associate in science degree;`;

  constructor(
    public dataService: DataService,
    private snackbarService: SnackbarService,
    private papa: Papa,
    private _routeService: RouteService,
    private zone: NgZone,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit(): void {
    const filteredCustomChartAttrs = this.customChartAttributes.filter(
      (attr) => attr.columnProp !== this.customChartForm.value.xaxis,
    );
    this.customChartForm.patchValue({
      filteredXaxisAttrs: [...this.customChartAttributes],
      filteredAttrAttrs: [...filteredCustomChartAttrs],
      filteredGroupAttrs: [...filteredCustomChartAttrs],
    });

    this.subscription.add(
      this.dataService.getPendingData().subscribe((pending) => {
        this.dataPending = pending;
      }),
    );

    this.subscription.add(
      this.dataService.getData().subscribe((dataStream) => {
        if (dataStream.data) {
          this.cohortData = dataStream.data as CohortReturn;
          this.tableData.data = this.cohortData.students;
          this.students = this.cohortData.students;
          this.studentDataKeys = Object.keys(this.cohortData.students[0]);
          this.filterSelectObj.forEach((obj: FilterSelect) => {
            obj.options = this.cohortData.filters[obj.columnProp];
            if (this.multiSelectColumns.includes(obj.columnProp)) {
              obj.defaultValue = this.cohortData.filters[obj.columnProp];
            }
          });
          this.generateDropoutProneChart();
          this.generateCustomChart();
        }

        dataStream.error &&
          this.snackbarService.open(dataStream.error.message, 'error');
      }),
    );
  }

  ngAfterViewInit(): void {
    this.tableData.paginator = this.paginator;
    this.tableData.filterPredicate = this.createFilter();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.browserOnly(() => {
      if (this.root) {
        this.root.dispose();
      }
    });
  }

  filterChange(filter: FilterSelect) {
    this.filterDictionary.set(filter.columnProp, filter.defaultValue as any);
    const jsonString = JSON.stringify(
      Array.from(this.filterDictionary.entries()),
    );
    this.tableData.filter = jsonString;
    this.generateCustomChart();
  }

  // handle enable/disable multi-select 'All' value
  clickMultiSelect(
    itemSelected: string,
    selected: boolean,
    filter: FilterSelect,
  ) {
    if (itemSelected === 'All' && selected) {
      filter.defaultValue = filter.options;
      this.filterChange(filter);
      return;
    }

    if (itemSelected === 'All' && !selected) {
      filter.defaultValue = [];
      this.filterChange(filter);
      return;
    }

    filter.defaultValue = (filter.defaultValue as string[]).filter(
      (str) => str !== 'All',
    );

    if (selected) {
      (filter.defaultValue as string[]).push(itemSelected);
    } else {
      filter.defaultValue = (filter.defaultValue as string[]).filter(
        (str) => str !== itemSelected,
      );
    }

    if (
      (filter.defaultValue as string[]).length === filter.options!.length &&
      !(filter.defaultValue as string[]).includes('All')
    ) {
      (filter.defaultValue as string[]).push('All');
    }

    this.filterChange(filter);
  }

  isOptionDisabled(itemSelected: string) {
    return this.disabledValues.includes(itemSelected);
  }

  // Custom filter method fot Angular Material Datatable
  createFilter() {
    const multiSelectColumProps: string[] = [...this.multiSelectColumns];

    const filterFunction = function (record: any, filter: string): boolean {
      const map = new Map(JSON.parse(filter));
      let isMatch = false;
      for (const [key, value] of map) {
        if (typeof key === 'string' && multiSelectColumProps.includes(key)) {
          if (
            (value as string[]).includes('All') ||
            (value as string[]).length === 0
          ) {
            isMatch = true;
          } else {
            if (key === 'tier') {
              const zeroIndex = (value as any[]).findIndex((x) => x === 0);
              (value as any[])[zeroIndex] = null;
            }
            isMatch = (value as any[]).includes(
              record[key as keyof Partial<StudentReturn>],
            );
            if (!isMatch) return false;
          }
        } else if (key === 'at_risk') {
          if (value === 'All') {
            isMatch = true;
          } else if (value === 'Yes') {
            isMatch = record[key as keyof Partial<StudentReturn>] === true;
          } else {
            isMatch = record[key as keyof Partial<StudentReturn>] === false;
          }
          if (!isMatch) return false;
        } else {
          isMatch =
            value === 'All' ||
            record[key as keyof Partial<StudentReturn>] == value;
          12;
          if (!isMatch) return false;
        }
      }
      return isMatch;
    };
    return filterFunction;
  }

  // Reset table filters
  resetFilters() {
    this.filterSelectObj.forEach((value, key) => {
      if (this.multiSelectColumns.includes(value.columnProp)) {
        value.defaultValue = ['All'];
      } else {
        value.defaultValue = 'All';
      }
    });
    this.tableData.filter = '';
    this.generateCustomChart();
  }

  exportData(): void {
    if (isPlatformBrowser(this.platformId)) {
      const csvData = this.papa.unparse(this.tableData.filteredData as any);
      const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const pom = document.createElement('a');
      pom.href = url;
      pom.setAttribute('download', 'export.csv');
      pom.click();
    }
  }

  viewStudent(student: any) {
    const queryParams = {
      student: `${student.name} (${student.uwf_id})`,
    };
    this._routeService.navigateNewTab('/student-profile', queryParams);
  }

  browserOnly(f: () => void) {
    if (isPlatformBrowser(this.platformId)) {
      this.zone.runOutsideAngular(() => {
        f();
      });
    }
  }

  generateDropoutProneChart() {
    this.fticDropoutProneChart && this.fticDropoutProneChart.destroy();

    setTimeout(() => {
      const customChartData = this.students.filter(
        (stu) => stu.dropout_risk === 'High Risk' && stu.admit_type === 'FTIC',
      );
      const groupedByCohorts = _.groupBy(customChartData, 'cohort');
      const groupedByColleges = _.groupBy(customChartData, 'college');
      const cohortLabels = Object.keys(groupedByCohorts).sort();

      this.fticDropoutProneChart = new Chart('dropout-prone-chart', {
        type: 'bar',
        data: {
          labels: cohortLabels,
          datasets: Object.entries(groupedByColleges)
            .sort((a, b) => a[0].localeCompare(b[0]))
            .map(([college, students]) => {
              const data: number[] = [];

              cohortLabels.forEach((cohort) => {
                data.push(
                  students.filter((stu) => stu.cohort === Number(cohort))
                    .length,
                );
              });

              return { label: college, data };
            }),
        },
        options: {
          maintainAspectRatio: false,
          plugins: {
            datalabels: {
              color: '#000', // Text color
              anchor: 'center', // Position relative to bar (start, center, end)
              align: 'center', // Align text (top, middle, bottom)
            },
            legend: {
              labels: {
                font: {
                  size: 15,
                  family:
                    "'Gotham SSm A','Gotham SSm B', 'Arial', 'sans-serif'",
                },
              },
            },
          },
          scales: {
            x: {
              display: true,
              title: {
                display: true,
                text: 'Cohort',
                font: {
                  size: 16,
                  family:
                    "'Gotham SSm A','Gotham SSm B', 'Arial', 'sans-serif'",
                },
              },
            },
            y: {
              beginAtZero: true,
              display: true,
              title: {
                display: true,
                text: 'Count',
                font: {
                  size: 16,
                  family:
                    "'Gotham SSm A','Gotham SSm B', 'Arial', 'sans-serif'",
                },
              },
            },
          },
        },
      });

      this.fticDropoutProneChart.update();
    });
  }

  handleCustomChartXaxisUpdate(event: MatSelectChange) {
    this.generateCustomChart();
    this.customChartForm.patchValue({
      filteredAttrAttrs: this.customChartAttributes.filter(
        (attr) =>
          attr.columnProp !== event.value &&
          attr.columnProp !== this.customChartForm.value.group,
      ),
      filteredGroupAttrs: this.customChartAttributes.filter(
        (attr) =>
          attr.columnProp !== event.value &&
          attr.columnProp !== this.customChartForm.value.attribute,
      ),
    });
  }

  handleCustomChartAttributeUpdate(event: MatSelectChange) {
    this.generateCustomChart();
    this.customChartForm.patchValue({
      filteredXaxisAttrs: this.customChartAttributes.filter(
        (attr) =>
          attr.columnProp !== event.value &&
          attr.columnProp !== this.customChartForm.value.group,
      ),
      filteredGroupAttrs: this.customChartAttributes.filter(
        (attr) =>
          attr.columnProp !== event.value &&
          attr.columnProp !== this.customChartForm.value.xaxis,
      ),
    });
  }

  handleCustomChartGroupUpdate(event: MatSelectChange) {
    this.generateCustomChart();
    this.customChartForm.patchValue({
      filteredXaxisAttrs: this.customChartAttributes.filter(
        (attr) =>
          attr.columnProp !== event.value &&
          attr.columnProp !== this.customChartForm.value.attribute,
      ),
      filteredAttrAttrs: this.customChartAttributes.filter(
        (attr) =>
          attr.columnProp !== event.value &&
          attr.columnProp !== this.customChartForm.value.xaxis,
      ),
    });
  }

  generateCustomChart() {
    if (!this.tableData.filteredData.length) return;

    const { xaxis, attribute, group } = this.customChartForm.value;
    const groupedByXAxis = _.groupBy(this.tableData.filteredData, xaxis!);
    const hasAll = !!(xaxis && attribute && group);

    setTimeout(() => {
      this.browserOnly(() => {
        if (!this.root) this.root = am5.Root.new('custom-chart');

        // Remove amcharts logo below graphs
        this.root._logo!.dispose();

        // Set themes
        // https://www.amcharts.com/docs/v5/concepts/themes/
        this.root.setThemes([am5themes_Animated.new(this.root)]);

        // if chart is not empty then erase it for new data coming
        if (this.chart) {
          this.chart.series.pop();
          this.root.container.children.pop();
        }

        // Create chart
        // https://www.amcharts.com/docs/v5/charts/xy-chart/
        this.chart = this.root.container.children.push(
          am5xy.XYChart.new(this.root, {
            panX: false,
            panY: false,
            wheelX: 'none',
            wheelY: 'none',
          }),
        );

        // Add cursor
        // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
        const cursor = this.chart.set(
          'cursor',
          am5xy.XYCursor.new(this.root, {}),
        );
        cursor.lineY.set('visible', false);

        // Add scrollbar
        // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/

        // Scrollbar X
        var scrollbarX = am5.Scrollbar.new(this.root, {
          orientation: 'horizontal',
        });

        this.chart.set('scrollbarX', scrollbarX);
        this.chart.bottomAxesContainer.children.push(scrollbarX);

        // Create axes
        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
        const xRenderer = am5xy.AxisRendererX.new(this.root, {
          minGridDistance: 30,
        });
        xRenderer.labels.template.setAll({
          text: '{realName}',
          rotation: hasAll ? -75 : 0,
        });

        const xAxis = this.chart.xAxes.push(
          am5xy.CategoryAxis.new(this.root, {
            maxDeviation: 0,
            categoryField: 'category',
            renderer: xRenderer,
          }),
        );

        const yAxis = this.chart.yAxes.push(
          am5xy.ValueAxis.new(this.root, {
            maxDeviation: 0.3,
            renderer: am5xy.AxisRendererY.new(this.root, {}),
            min: 0,
          }),
        );

        // Create series
        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
        const series = this.chart.series.push(
          am5xy.ColumnSeries.new(this.root, {
            name: 'Series 1',
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: 'value',
            sequencedInterpolation: true,
            categoryXField: 'category',
            tooltip: am5.Tooltip.new(this.root, {
              labelText: '{valueY}',
            }),
          }),
        );

        series.columns.template.setAll({
          fillOpacity: 0.9,
          strokeOpacity: 0,
        });
        series.columns.template.adapters.add('fill', (fill, target: any) => {
          return this.chart
            .get('colors')!
            .getIndex(series.columns.indexOf(target));
        });

        series.columns.template.adapters.add(
          'stroke',
          (stroke, target: any) => {
            return this.chart
              .get('colors')!
              .getIndex(series.columns.indexOf(target));
          },
        );

        const customChartData: any[] = [];
        let startingPoint = 0; // Starting range for a label at bottom
        let endingPoint = 0; // Ending range for a label at bottom

        // process data ant prepare it for the chart
        Object.entries(groupedByXAxis)
          .sort((a, b) => a[0].localeCompare(b[0]))
          .forEach(([xaxisKey, students]) => {
            const groupedByAttr = _.groupBy(students, attribute!);

            Object.entries(groupedByAttr)
              .sort((a, b) => a[0].localeCompare(b[0]))
              .forEach(([attrKey, students]) => {
                const tempArray: any[] = [];

                // add items
                const groupedByGroup = _.groupBy(students, group!);
                Object.entries(groupedByGroup)
                  .sort((a, b) => a[0].localeCompare(b[0]))
                  .forEach(([groupKey, students]) => {
                    tempArray.push({
                      category: xaxisKey + '_' + attrKey + '_' + groupKey,
                      realName: this.collegesMap.hasOwnProperty(groupKey)
                        ? this.collegesMap[groupKey]
                        : groupKey === 'null'
                          ? 'NA'
                          : groupKey,
                      value: students.length,
                      attrKey,
                    });

                    ++endingPoint;
                  });

                // push to the final data
                am5.array.each(tempArray, function (item) {
                  customChartData.push(item);
                });

                // create range for attribute label at the bottom
                const range = xAxis.makeDataItem({});
                xAxis.createAxisRange(range);

                range.set('category', tempArray[0].category);
                range.set(
                  'endCategory',
                  tempArray[tempArray.length - 1].category,
                );

                const label = range.get('label');

                label!.setAll({
                  text: this.collegesMap.hasOwnProperty(tempArray[0].attrKey)
                    ? this.collegesMap[tempArray[0].attrKey]
                    : tempArray[0].attrKey,
                  dy: 50,
                  fontWeight: 'bold',
                  // tooltipText: tempArray[0].attrKey,
                });

                const tick = range.get('tick');
                tick!.setAll({
                  visible: true,
                  strokeOpacity: 1,
                  length: 70,
                  location: 0,
                });

                const grid = range.get('grid');
                grid!.setAll({ strokeOpacity: 1 });
              });

            // Create range for xaxis label at the bottom
            const range = xAxis.makeDataItem({});
            xAxis.createAxisRange(range);

            range.set('category', customChartData[startingPoint].category);
            range.set(
              'endCategory',
              customChartData[customChartData.length - 1].category,
            );

            const label = range.get('label');

            label!.setAll({
              text: this.collegesMap.hasOwnProperty(xaxisKey)
                ? this.collegesMap[xaxisKey]
                : xaxisKey === 'null'
                  ? 'NA'
                  : xaxisKey,
              dy: 100,
              fontWeight: 'bold',
              // tooltipText: xaxisKey,
            });

            const tick = range.get('tick');
            tick!.setAll({
              visible: true,
              strokeOpacity: 1,
              length: 120,
              location: 0,
            });

            const grid = range.get('grid');
            grid!.setAll({ strokeOpacity: 1 });

            startingPoint = endingPoint;
          });

        // Add data labels
        const rootCopy = this.root;
        series.bullets.push(function () {
          return am5.Bullet.new(rootCopy, {
            locationY: 0,
            sprite: am5.Label.new(rootCopy, {
              text: '{valueY}',
              fill: am5.color(0xffffff),
              centerY: am5.p100,
              centerX: am5.p50,
              populateText: true,
              shadowColor: am5.color(0x000),
              shadowBlur: 5,
              shadowOffsetX: 2,
              shadowOffsetY: 2,
            }),
          });
        });

        // add range for the last grid
        const range = xAxis.makeDataItem({});
        xAxis.createAxisRange(range);
        range.set(
          'category',
          customChartData[customChartData.length - 1].category,
        );
        const tick = range.get('tick');
        tick!.setAll({
          visible: true,
          strokeOpacity: 1,
          length: 90,
          location: 1,
        });

        const grid = range.get('grid');
        grid!.setAll({ strokeOpacity: 1, location: 1 });

        xAxis.data.setAll(customChartData);
        series.data.setAll(customChartData);

        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        series.appear(1000);
        this.chart.appear(1000, 100);
      });
    });
  }

  formatMultiSelectValuesDisplay(filter: FilterSelect) {
    if ((filter.defaultValue as any[]).includes('All')) {
      return 'All';
    }

    if (filter.name === 'TIER') {
      return [
        ...new Set((filter.defaultValue as any[]).map((x) => x || 'No Tier')),
      ];
    }

    return [...new Set(filter.defaultValue)];
  }

  getFiltersText() {
    const selectedFilters = this.filterSelectObj.filter((obj) => {
      if (Array.isArray(obj.defaultValue) && obj.defaultValue.includes('All')) {
        return false;
      }
      if (obj.defaultValue === 'All') return false;

      return true;
    });

    const text = selectedFilters
      .map((obj) => {
        return `${obj.name}: ${
          Array.isArray(obj.defaultValue)
            ? [...new Set(obj.defaultValue)]
                .map((value) => value || 'NA')
                .join(' & ')
            : obj.defaultValue
        }`;
      })
      .join(', ');

    return text || 'None';
  }

  getLeftFiltersText() {
    const queryFilters = this.cohortData.query;
    return `Years: ${queryFilters.years.toString()} | 
      Admit types: ${queryFilters.admit_types.toString()} | 
      Tiers: ${queryFilters.tiers.toString()} | 
      Financial aid status: ${queryFilters.financial_aid} | 
      HS GPA: ${queryFilters.high_school_gpa.toString()} | 
      UWF GPA: ${queryFilters.uwf_gpa.toString()}`;
  }

  navigateToGlossaryOfTerms(termValue: string) {
    this._routeService.navigateNewTab('/glossary-of-terms', {
      term_value: termValue,
    });
  }
}
